import React, { Component } from "react";
import { TextField } from "@material-ui/core";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";

import FleetDialog from "../../../ui/dialogbox/FleetDialog";
import { commonJs } from "../../../../common/common";
import {
  LABELS,
  NOTIFY,
  SUCCESS_MSG,
  WARNINGS,
} from "../../../../common/consts";
import { API_CPanel } from "../../../../apihandler/CPanel";

import { CPANEL_ACTIONS } from "../../../../actions/CpanelActions";

class CompanyDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      record: {},
      showDialog: false,
    };
  }

  componentDidMount() {
    const { childRef } = this.props;
    childRef(this);
  }

  componentWillUnmount() {
    const { childRef } = this.props;
    childRef(undefined);
  }

  toggleDialog = (record) => {
    const { showDialog } = this.state;
    if (record.id === undefined) {
      console.log("toggleDialog Add:  ", record, !showDialog);
      // this.props.setPointEdit({
      //   pointId: "",
      // });
      if (record.add) {
        this.setState({
          showDialog: !showDialog,
          record: {},
        });
      } else {
        // Close
        this.setState({
          showDialog: !showDialog,
        });
      }
    } else {
      // Edit -> Open
      this.setState({
        showDialog: !showDialog,
        record: record,
      });
      console.log("Edit: ", record);
    }
  };

  saveRecord = () => {
    const companyName = document.getElementById("comName").value.trim();
    const companyLogo = document.getElementById("comLogo").value.trim();

    let self = this;

    if (companyName === "") {
      commonJs.showNotify(
        self.props,
        NOTIFY.WARNING,
        WARNINGS.COMPANY_NAME_SHOULD_NOT_BE_EMPTY
      );
      return false;
    }

    const args = {
      id: this.state.record.id || 0,
      name: companyName,
      logo: companyLogo,
    };

    console.log("save Record: ", args);

    this.props.setLoading({
      loading: true,
    });

    API_CPanel.manageCompany(args)
      .then((res) => {
        console.log("manageCompany: ", res);
        if (res.Result === 200) {
          commonJs.showNotify(
            self.props,
            NOTIFY.SUCCESS,
            SUCCESS_MSG.COMPANY_SAVED
          );
          self.props.loadGrid();
          self.setState({
            showDialog: false,
          });
          self.props.setLoading({
            loading: false,
          });
        } else {
          commonJs.showNotify(self.props, NOTIFY.WARNING, res.Reason);
        }
      })
      .catch((err) => {
        console.log("Error: ", err);
      });

    return;
  };

  render() {
    const { record, showDialog } = this.state;

    return (
      <FleetDialog
        id="companyDialog"
        open={showDialog}
        onCloseSettings={this.toggleDialog}
        title={record.id ? LABELS.EDIT_COMPANY : LABELS.ADD_COMPANY}
        maxWidth="xs"
        fullWidth={false}
        cancelButton={true}
        cancelAction={this.toggleDialog}
        saveButton={true}
        saveAction={this.saveRecord}
        saveBtnLabel="OK"
        disableBackdropClick={true}
        disableBackdrop={true}
        classNameBody="zonePopupBody"
        classNameWrapper="zonePopupWrapper"
        draggable
      >
        <div className="grid">
          <div className="row">
            <TextField
              id="comName"
              label={LABELS.COMPANY_NAME}
              classes={{ root: "txtfield" }}
              autoFocus={true}
              variant="outlined"
              size="small"
              onMouseDown={(e) => e.stopPropagation()}
              defaultValue={record.name || ""}
            />
          </div>
          <div className="row">
            <TextField
              id="comLogo"
              label={LABELS.COMPANY_LOGO}
              classes={{ root: "txtfield" }}
              variant="outlined"
              size="small"
              onMouseDown={(e) => e.stopPropagation()}
              defaultValue={record.logo || "/img/userthumbnails/logo.png"}
            />
          </div>
        </div>
      </FleetDialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    setLoading: (values) => {
      dispatch({
        type: CPANEL_ACTIONS.SET_LOADING,
        values,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(CompanyDialog));
